import React from "react";
import { FaWhatsapp, FaInstagram } from "react-icons/fa";

const FloatingButtons = () => {
  return (
    <div
      style={{
        position: "fixed",
        bottom: "30px",
        right: "30px",
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
        gap: "12px",
      }}
      className="floating-action-buttons"
    >
      {/* WhatsApp Button */}
      <a
        href="https://wa.me/919655900042"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          width: "50px",
          height: "50px",
          borderRadius: "50%",
          backgroundColor: "#25D366",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          boxShadow: "0 4px 16px rgba(37, 211, 102, 0.3)",
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
          textDecoration: "none",
        }}
        className="floating-btn whatsapp"
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "scale(1.1)";
          e.currentTarget.style.boxShadow = "0 8px 24px rgba(37, 211, 102, 0.5)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "scale(1)";
          e.currentTarget.style.boxShadow = "0 4px 16px rgba(37, 211, 102, 0.3)";
        }}
        title="Chat with us on WhatsApp"
      >
        <FaWhatsapp size={26} />
      </a>

      {/* Instagram Button */}
      <a
        href="https://www.instagram.com/idealcorporateservices/"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          width: "50px",
          height: "50px",
          borderRadius: "50%",
          background: "linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          boxShadow: "0 4px 16px rgba(220, 39, 67, 0.3)",
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
          textDecoration: "none",
        }}
        className="floating-btn instagram"
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "scale(1.1)";
          e.currentTarget.style.boxShadow = "0 8px 24px rgba(220, 39, 67, 0.5)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "scale(1)";
          e.currentTarget.style.boxShadow = "0 4px 16px rgba(220, 39, 67, 0.3)";
        }}
        title="Follow us on Instagram"
      >
        <FaInstagram size={26} />
      </a>
    </div>
  );
};

export default FloatingButtons;
